import React,{useEffect,useSyncExternalStore}from'react';
import{getMacroRegime,subscribeMacroRegime}from'../data/macroRegimeStore.js';
import{syncSectorTurnAlerts}from'../data/sectorTurnAlerts.js';

export default function SectorTurnDashboardBridge(){
 const snap=useSyncExternalStore(subscribeMacroRegime,getMacroRegime,getMacroRegime);
 const turnSignature=(snap?.sectorTurns?.events||[]).map(e=>e.eventKey).sort().join('|');
 useEffect(()=>{let alive=true;if(!turnSignature||snap?.sectorTurns?.status!=='LIVE')return()=>{alive=false};syncSectorTurnAlerts(snap.sectorTurns).then(r=>{if(alive&&r.created>0)window.dispatchEvent(new CustomEvent('stockcritter:alerts-changed',{detail:{created:r.created}}))}).catch(()=>{});return()=>{alive=false}},[turnSignature,snap?.sectorTurns?.status]);
 return null;
}
